import { ReactNode } from 'react'
import { useTranslation } from 'react-i18next'

// local imports
import { IOccupancyFirmData } from 'types/DashboardType'
import { saveAsExcelFile } from 'utils/Miscellaneous'
import ExportBtn from './ExportBtn'

interface CompProps {
  children: ReactNode
  excelData: any
}

export default function FirmOccupancyDist({ excelData, children }: CompProps) {
  const { t } = useTranslation()

  const handleExport = () => {
    import('xlsx').then((xlsx) => {
      let heading = [
        [
          t('most-used-words.firm'),
          t('most-used-words.location'),
          t('dashboard.num-of-coming-office'),
          t('dashboard.num-of-not-coming-office'),
          t('dashboard.total-firm-notification'),
        ],
      ]

      const arr = excelData?.map((res: any) => {
        const { firmName, locationName, incomingCount, notComingCount, reservationCount } = res || {}

        return {
          FirmName: firmName || '---',
          LocationName: locationName || '',
          IncomingCount: incomingCount,
          NotComingCount: notComingCount,
          ReservationCount: reservationCount,
        }
      })

      const totalRow = arr.reduce(
        (acc: IOccupancyFirmData, curr: IOccupancyFirmData) => {
          acc.incomingCount += curr.incomingCount || 0
          acc.notComingCount += curr.notComingCount || 0
          acc.reservationCount += curr.reservationCount || 0
          return acc
        },
        {
          FirmName: '',
          LocationName: t('most-used-words.total'),
          IncomingCount: 0,
          NotComingCount: 0,
          ReservationCount: 0,
        }
      )

      let heading2 = {
        FirmName: '',
        IncomingCount: t('dashboard.excel.total-num-of-coming-office'),
        NotComingCount: t('dashboard.excel.total-num-of-not-coming-office'),
        ReservationCount: t('dashboard.excel.total-office-notification'),
      }

      arr.push(...[{}, heading2, totalRow])

      /* header */
      const ws = xlsx.utils.book_new()
      xlsx.utils.sheet_add_aoa(ws, heading)
      const worksheet = xlsx.utils.sheet_add_json(ws, arr!, { origin: 'A2', skipHeader: true })
      const workbook = { Sheets: { data: worksheet }, SheetNames: ['data'] }
      const excelBuffer = xlsx.write(workbook, { bookType: 'xlsx', type: 'array' })
      saveAsExcelFile(excelBuffer, t('dashboard.firm-office-fullness'))
    })
  }

  return (
    <>
      {!!excelData && excelData?.length ? <ExportBtn handleExport={handleExport} /> : null}
      {children}
    </>
  )
}
